module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_447269870_L-d244669019bfd7517061967990abaae2.jpg";